import {receiptServices} from "../../../services/api/receipts.endpoints";
import {setAllCurrencies, setPairingRate, setReceiptData} from "../../../features/financeReceiptSlice";
import {setDisplayErrorSnackBar} from "../../../features/userSlice";
import store from "../../../store";

async function getAllReceiptData(oauthTokenHeader: any, from_date: any, to_date: any) {
    try {
        const response = await receiptServices.getReceiptData(oauthTokenHeader, from_date, to_date);
        if (!response || typeof response.status !== "number") {
            throw new Error("Invalid response from server");
        }

        if (response.status === 204) {
            store.dispatch(setReceiptData([]));
            return [];
        }

        if (response.status === 200) {
            const data = response?.data?.data ?? [];
            store.dispatch(setReceiptData(data));
            return data;
        }

        throw new Error(`Unexpected status code: ${response.status}`);
    } catch (error: any) {
        store.dispatch(setDisplayErrorSnackBar({ message: error?.parsedText || "Something went wrong while fetching receipts.", type: "error" }));
    }
};

async function getAllCurrencies(oauthTokenHeader:any) {
    try {
      const response = await receiptServices.getAllCurrencies(oauthTokenHeader);
      if (!response || !response.status || response.status !== 200) {
          throw new Error("Failed to get currencies");
      } else  {
         store.dispatch(setAllCurrencies(response?.data?.data));
      }
    } catch (error:any) {
        store.dispatch(setDisplayErrorSnackBar({message: error?.parsedText || "Something went wrong while fetching currencies.", type: "error"}));
    }
}

async function getPairingRate(oauthTokenHeader: string, QUERY_ID: string, from_date: any, to_date: any) {
    try {
        const response = await receiptServices.getPairingRate(oauthTokenHeader, QUERY_ID, from_date, to_date);
        if (!response || !response.status || response.status !== 200) {
            throw new Error("Failed to get pairing rate");
        } else {
            store.dispatch(setPairingRate(response?.data?.data));
        }
    } catch (error: any) {
        store.dispatch(setDisplayErrorSnackBar({ message: error?.parsedText || "Unknown error occurred", type: "error" }));
    }
}

export const ReceiptsEndPointLogic = {
    getAllReceiptData, getAllCurrencies, getPairingRate
};
